<template>
  <div class="content">
    <div class="basic">
      <div class="headline">
        <p class="title">
          {{title}}
        </p>
        <div class="info">
          <div class="left">
            <span class="name">发布者</span>
            <span>{{publisher}}</span>
          </div>
          <div class="seprate"></div>
          <div class="right">
            <span class="name">状态</span>
            <span>{{status}}</span>
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="item">
          <span class="name">分类</span>
          <div class="input">
            <select v-model="baseInfo.id">
              <option :value="b.id" v-for="(b, i) in bases" :key="i">{{b.title}}</option>
            </select>
            <img src="@assets/img/resources/down.svg" alt="down" class="down">
          </div>
        </div>
        <div class="item">
          <span class="name">类型</span>
          <div class="input">
            <select v-model="classInfo.id">
              <option :value="c.id" v-for="(c, i) in classes" :key="i">{{c.title}}</option>
            </select>
            <img src="@assets/img/resources/down.svg" alt="down" class="down">
          </div>
        </div>
        <div class="item">
          <span class="name">姓名</span>
          <div class="input">
            <input class="enter" type="text" v-model="name">
          </div>
        </div>
        <div class="item">
          <span class="name">手机</span>
          <div class="input">
            <input class="enter" type="text" v-model="tel">
          </div>
        </div>
        <div class="item" v-if="classInfo.id == 6">
          <span class="name">配置车辆</span>
          <div class="input bus">
            <!-- <input class="enter" type="text" v-model="bus.name"> -->
            <select v-model="bus.id" :class="{disabled: bus.id === -1}">
              <option value="-1" disabled>请选择</option>
              <option :value="b.id" v-for="(b, i) in bus.list" :key="i">{{b.title}}</option>
            </select>
            <img src="@assets/img/resources/bus.svg" alt="bus">
          </div>
        </div>
        <div class="item" :style="{visibility: 'hidden'}">
          <span class="name">报价单位</span>
          <div class="input">
            <input class="enter" type="text">
          </div>
        </div>
      </div>
      <!-- <div class="gps">
        <p class="title">GPS设备</p>
        <div class="item">
          <div class="block left">
            <img src="@assets/img/resources/gps.svg" alt="gps">
            <span class="name">GPS设备</span>
            <span class="value">12号车沪JZ0739</span>
          </div>
          <div class="block right">
            <img src="@assets/img/resources/locate.svg" alt="gps">
            <span class="name">位置</span>
            <span class="value">近威海路青海路中心西北 0.118公里,在上海市内</span>
          </div>
        </div>
        <div class="item">
          <div class="block left">
            <img src="@assets/img/resources/point.svg" alt="gps">
            <span class="name">坐标</span>
            <span class="value">121.460434,31.23035</span>
          </div>
          <div class="block right">
            <img src="@assets/img/resources/time.svg" alt="gps">
            <span class="name">时间</span>
            <span class="value">2018-09-04 11:30:30</span>
          </div>
        </div>
      </div> -->
      <div class="remark">
        <span class="mark">
          备注
        </span>
        <textarea v-model="remark">
        </textarea>
        <span class="count">{{`${remark.length}/200`}}</span>
      </div>
    </div>
    <div class="about">
      <div class="toggler">
        <div :class="{toggle: true, on: toggleOn.id === t.id}" v-for="(t, i) in toggles" :key="i" @click="switchToggle(t)">
          {{t.title}}
        </div>
      </div>
      <div class="tasks" v-if="toggleOn.id === toggles[0].id">
        <div class="titleline">
          <span class="title">任务主题</span>
          <span class="type">任务类型</span>
          <span class="status">状态</span>
          <span class="interviewTime">采访时间</span>
          <span class="endTime">结束时间</span>
        </div>
        <empty :msg="'暂无分配记录'" v-if="records.length === 0" />
        <div class="content" v-for="(l, i) in records" :key="i">
          <div class="item">
            <span class="theme">
              <p class="words">
                {{l.title}}
              </p>
            </span>
            <span class="type">{{l.iview_type}}</span>
            <span class="status">{{l.status}}</span>
            <span class="interviewTime">{{l.start}}</span>
            <span class="endTime">{{l.end}}</span>
          </div>
        </div>
      </div>
      <div class="records" v-if="toggleOn.id === toggles[1].id">
        <div class="titleline">
          <span class="title">休假</span>
          <span class="status">状态</span>
          <span class="interviewTime">申请使用时间</span>
          <span class="endTime">分配时间</span>
          <span class="handler">操作者</span>
          <span class="cancelTime">手动取消／结束时间</span>
          <span class="handle">操作</span>
        </div>
        <empty :msg="'暂无休假记录'" v-if="vacations.length === 0" />
        <div class="content" v-for="(l, i) in vacations" :key="i">
          <div class="item">
            <span class="title">
              <span class="tag">{{l.rest_type}}</span>
            </span>
            <span class="status">{{l.status_name}}</span>
            <span class="interviewTime">
              <span>{{l.rest_start}}</span>
              <span>{{l.rest_end}}</span>
            </span>
            <span class="endTime">{{l.raw_add_time}}</span>
            <span class="handler">
              {{l.opt_name}}
            </span>
            <span class="cancelTime">
              {{l.opt_time}}
            </span>
            <span class="handle">
              <span class="btn" v-if="l.status - 0 === 0" @click="cancelVacation(l.rest_id)">取消</span>
              <span class="btn" v-if="l.status - 0 === 1" @click="finishVacation(l.rest_id)">取消</span>
            </span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex"></pages>
    </div>
    <div class="footline" :style="{width: `calc(100vw - ${footLineGap}px)`}">
      <div class="btn left" @click="delPeople()">删除人员</div>
      <div class="btn greenBtn" @click="saveUpdates()">保存人员</div>
    </div>
  </div>
</template>

<script>
import pages from '@components/pages'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'

export default {
  name: 'equipmentDetail',
  components: {
    pages, empty
  },
  computed: {
    baseId() {
      return this.baseInfo.id
    }
  },
  watch: {
    baseId(n, o) {
      this.changeClasses(n)
    }
  },
  data() {
    return {
      page: {
        page_count: 0,
        pageIndex: 1,
        pageSize: 10
      },
      title: '',
      remark: '',
      publisher: '',
      status: '',
      name: '',
      tel: '',
      bus: {
        name: '',
        id: '',
        list: []
      },
      toggles: [
        {
          title: '分配记录',
          id: 1
        },
        {
          title: '休假情况',
          id: 2
        }
      ],
      toggleOn: {},
      records: [],
      vacations: [],
      bases: [],
      classes: [],
      baseInfo: {
        id: '',
        title: ''
      },
      classInfo: {
        id: '',
        title: ''
      },
      footLineGap: 230
    }
  },
  methods: {
    changeClasses(s) {
      // 切换分类，分类和类型联动，默认选择类型第一项, 如果有已选项则选已选项
      this.bases.forEach((i) => {
        if (s === i.id) {
          this.classes = i.list
          let selected = null
          this.classes.forEach(c => {
            if (c.selected) {
              selected = c
            }
          })
          selected = selected || this.classes[0]
          this.$set(this.classInfo, 'id', selected.id)
        }
      })
    },
    switchToggle(t) {
      this.toggleOn = t
      this.getList()
    },
    getBuses(id) {
      // 获取采访车, 如有匹配项，则选中默认项
      const info = {}

      return common.myFetch(apis.Res_bus_list, info)
      .then((data) => {
        this.bus.list = data.list
        this.bus.list.forEach((b) => {
          if (b.id == id) {
            this.$set(this.bus, 'id', b.id)
          }
        })
      })
    },
    saveUpdates() {
      // 保存人员信息
      const person_id = this.$route.query.d
      const class_id = this.baseInfo.id
      const class_title = this.bases.map(i => {return i.id === class_id ? i.title : ''}).join('')
      const type_id = this.classInfo.id
      const type_title = this.classes.map(i => {return i.id === type_id ? i.title : ''}).join('')
      const title = this.name
      const phone = this.tel
      const device_id = this.bus.id
      const remark = this.remark

      const info = {
        person_id: person_id,
        class_id: class_id,
        class_title: class_title,
        type_id: type_id,
        type_title: type_title,
        title: title,
        phone: phone,
        device_id: device_id,
        remark: remark
      }

      common.myFetch(apis.Res_people_update, info, 'post')
      .then((data) => {
        if (data) {
          this.$toast(data)
          window.history.go(-1)
        }
      })
    },
    getDetail() {
      // 获取详情数据
      const info = {
        person_id: this.$route.query.d
      }

      common.myFetch(apis.Res_people_detail, info)
      .then((data) => {
        this.matchData(data.detail)
      })
    },
    matchData(data) {
      // 匹配数据到页面
      this.title = data.idstring
      this.publisher = data.user_name
      this.status = data.status_name
      this.name = data.title
      this.tel = data.phone
      this.bus.name = data.device_title
      this.bus.id = data.device_id - 0 || -1 // -1为默认值，文字为‘请选择’且置灰；意外情况：设备中存在id为0的情况
      this.remark = data.remark
      this.bases = data.class_list

      this.bases.forEach(i => {
        if (i.selected) {
          this.$set(this.baseInfo, 'id', i.id)
        }
      })

      this.getBuses(data.device_id)
    },
    cancelVacation(id) {
      // 取消休假
      const info = {
        rest_id: id
      }

      common.myFetch(apis.Res_people_vacation_cancel, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
        }
      })
    },
    finishVacation(id) {
      // 完成休假
      const info = {
        rest_id: id
      }

      common.myFetch(apis.Res_people_vacation_finish, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
        }
      })
    },
    getList() {
      // 获取关联列表
      const type = this.toggleOn.id
      if (type === 1) {
        this.getRecords()
      } else {
        this.getRests()
      }
    },
    getRecords() {
      // 获取人员分配记录
      const info = {
        person_id: this.$route.query.d,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(apis.Res_people_records, info)
      .then((data) => {
        this.records = data.list
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
      })
    },
    getRests() {
      // 获取人员休假列表
      const info = {
        person_id: this.$route.query.d,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(apis.Res_people_vacations, info)
      .then((data) => {
        this.vacations = data.list
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
      })
    },
    delPeople() {
      // 删除人员
      const info = {
        person_ids: this.$route.query.d
      }

      common.myFetch(apis.Res_people_del, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
          window.history.go(-1)
        }
      })
    }
  },
  mounted() {
    this.getDetail()
    this.switchToggle(this.toggles[0])
  }
}
</script>

<style lang="less" src="@assets/css/resource/peopleDetail.less" scoped>
</style>
